export default __webpack_public_path__ + "static/pagination-28adb6634670c88b6dfb46f9ec532f09.gif";